import type { WalletProvider } from '@/extensions/snk/lib/device-utils';
import { AppStoreBadge, Typography } from '@/shared-ui';
import downloadQrCode from '/images/download-qr-code.png';

export type DownloadAppProps = {
    mobileAppStorePlatform: WalletProvider;
};

export const DownloadApp = ({ mobileAppStorePlatform }: DownloadAppProps) => {
    return (
        <div>
            <Typography weight="regular" variant="h4" className="text-secondary mt-0">
                Download our app
            </Typography>
            <img
                src={downloadQrCode}
                alt="QR code to download the app"
                className="hidden md:block mt-4 w-[78px] h-auto"
            />
            <AppStoreBadge
                platform={mobileAppStorePlatform}
                variant="secondary"
                className="mt-4 w-full h-auto md:hidden"
            />
        </div>
    );
};
